import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ColorFormat } from '@app/components/color-picker/interfaces';

export interface DialogTarefaColunaData {
  noCor?: string | null;
  titulo?: string;
  tipo?: 'lista' | 'quadro';
}

@Component({
  selector: 'app-dialog-tarefa-coluna',
  templateUrl: './dialog-tarefa-coluna.component.html',
  styleUrls: ['./dialog-tarefa-coluna.component.css']
})
export class DialogTarefaColunaComponent {
  public noCor: string;
  public formatoCor: ColorFormat = 'hex';
  public readonly coresLista = ['#164b35', '#967300', '#693200', '#5d1f1a', '#48245d', '#123263', '#164555', '#50253f', '#F4F6F8'];
  public readonly coresQuadro = ['#005485', '#926424', '#386a27', '#7b3022', '#5f436e', '#8f3e65', '#34854a', '#00798e', '#FFFFFF'];

  public constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: DialogTarefaColunaData,
    private readonly dialogRef: MatDialogRef<DialogTarefaColunaComponent>
  ) {
    this.noCor = data.noCor ?? this.corPadrao;
  }

  public get titulo(): string {
    return this.data.titulo ?? 'Cor da lista';
  }

  public get corPadrao(): string {
    return this.data.tipo === 'quadro' ? '#FFFFFF' : '#F4F6F8';
  }

  public get cores(): string[] {
    return this.data.tipo === 'quadro' ? this.coresQuadro : this.coresLista;
  }

  public selecionarCor(cor: string): void {
    this.noCor = cor;
  }

  public removerCor(): void {
    this.dialogRef.close(this.corPadrao);
  }

  public salvar(): void {
    this.dialogRef.close(this.noCor);
  }

  public cancelar(): void {
    this.dialogRef.close();
  }
}
